/* eslint-disable react/jsx-props-no-spreading */
import * as React from 'react'
import PropTypes from 'prop-types'
import styled, { space, color, display } from '@style'

/**
 * Creative draft from
 * https://undraw.co
 */

function Icon({ size, ...props }) {
  return (
    <svg width={size} height={size} viewBox="0 0 858.081 750.015" {...props}>
      <path
        d="M78.606 668.906a102.532 102.532 0 00-8.998-28.887l-.643-1.33-4.776 5.296 3.539-7.888-.231-.458a188.613 188.613 0 00-10.368-17.989l-.702-1.074-.936 1.038.656-1.462-.329-.492c-4.686-7.029-8.286-11.474-8.321-11.519l-1.018-1.252-.655 1.493c-.12.274-12.02 27.693-13.595 54.787l-.025.422 8.008 9.68-8.167-5.127.014 1.86a79.262 79.262 0 00.649 9.523q.54 4.075 1.27 7.957a4.243 4.243 0 012.172.678q-.847-4.338-1.46-8.917a76.8 76.8 0 01-.593-7.38l15.797 9.918-15.644-18.91c1.424-22.906 10.265-45.986 12.747-52.077a182.346 182.346 0 016.85 9.56l-5.464 12.183 7.79-8.638a186.512 186.512 0 019.322 16.252l-8.414 18.757 11.377-12.615a100.382 100.382 0 018.17 26.92c1.992 15.041 1.603 29.49-1.094 40.686-2.584 10.725-7.137 17.317-12.493 18.087a8.466 8.466 0 01-3.3-.196 4.898 4.898 0 01-2.961.904h-.292a11.607 11.607 0 005.424 1.457 9.84 9.84 0 001.403-.101c6.296-.905 11.325-7.881 14.159-19.643 2.757-11.45 3.161-26.18 1.132-41.503z"
        fill="#e6e6e6"
      />
      <path
        d="M60.983 729.362c-8.237 0-20.113-4.532-31.892-12.78a50.891 50.891 0 01-4.957-3.985l-1.32-1.205 4.989-1.437-6.642-.243-.28-.294C8.43 696.38.682 677.961.605 677.778L0 676.322l1.574.072c.157.007 3.9.183 9.525.981l.35.05v-.003l1.234.188a123.751 123.751 0 0113.63 2.864l.478.13 1.497 3.686-.227-3.306 1.373.396a66.228 66.228 0 0118.327 8.497c17.914 12.544 27.826 28.222 22.586 35.704-1.79 2.558-5.088 3.78-9.364 3.78zM26.84 712.314a48.567 48.567 0 003.4 2.632c16.407 11.489 34.024 15.834 38.469 9.489 4.443-6.346-5.666-21.415-22.075-32.905a64.16 64.16 0 00-16.381-7.815l.887 12.917-5.828-14.355a122.347 122.347 0 00-11.696-2.496l.644 9.375-4.011-9.88a123.253 123.253 0 00-7.138-.777c2.078 4.563 8.943 18.652 18.937 29.244l18.33.671z"
        fill="#e6e6e6"
      />
      <path fill="#3f3d56" d="M.337 728.233H324.37v2.241H.337z" />
      <path
        d="M777.185 172.947h-3.999V63.402A63.402 63.402 0 00709.785 0H477.698a63.402 63.402 0 00-63.402 63.402v600.974a63.402 63.402 0 0063.402 63.402h232.086a63.402 63.402 0 0063.402-63.402V250.923h3.999z"
        fill="#e6e6e6"
      />
      <path
        d="M712.343 16.495h-30.295a22.495 22.495 0 01-20.828 30.99H528.26a22.495 22.495 0 01-20.826-30.99h-28.296a47.348 47.348 0 00-47.348 47.348v600.092a47.348 47.348 0 0047.348 47.348h233.205a47.348 47.348 0 0047.347-47.348V63.843a47.348 47.348 0 00-47.347-47.348z"
        fill="#fff"
      />
      <path
        d="M602.08 245.023a73 73 0 1173-73 73.083 73.083 0 01-73 73zm0-144a71 71 0 1071 71 71.08 71.08 0 00-71-71zM588.08 666.023a37 37 0 1137-37 37.041 37.041 0 01-37 37zm0-72a35 35 0 1035 35 35.04 35.04 0 00-35-35zM858.08 448.419H708.502V298.84h149.58zm-147.579-2h145.58V300.84H710.5zM542.193 528.42H461.08v-81.113h81.112zm-79.112-2h77.112v-77.113H463.08z"
        fill="#3f3d56"
      />
      <circle cx={86.279} cy={207.438} r={32.928} fill="#2f2e41" />
      <circle cx={141.16} cy={246.638} r={39.2} fill="#2f2e41" />
      <path
        d="M186.352 584.04l-19.227 34.017s-25.143-25.143-11.832-31.798L176 579.604zM152.335 674.998l5.916 25.143-17.748 5.916-5.916-28.84 17.748-2.219z"
        fill="#ffb8b8"
      />
      <path
        d="M189.342 421.24l3.811 38.897s68.627 63.265 44.964 86.929-53.244 42.89-53.244 42.89l-13.31-9.613 30.318-41.412-61.378-43.63 14.05 182.655-21.445 5.916L85.041 499s-14.79-59.16 21.446-88.74zM145.68 699.402s11.092-14.05 16.269-1.48a175.693 175.693 0 018.134 26.623s19.227 28.84-10.353 25.142-20.706-17.008-20.706-17.008a9.903 9.903 0 01-4.437-9.613c.74-6.656 4.437-22.185 4.437-22.185s3.698-6.656 6.656-1.48z"
        fill="#2f2e41"
      />
      <path
        d="M176.369 602.898s6.286 6.285-4.067 16.638c0 0-1.48 28.84-14.79 25.883s-17.748-39.194-16.27-42.891-2.218-31.059 6.656-30.32 19.967 10.354 19.967 10.354-19.227 17.747-.74 29.58c0 0 4.807-1.85 9.244-9.244z"
        fill="#2f2e41"
      />
      <path
        d="M121.276 317.083l56.202 1.479c-12.385-17.576-14.716-38.31-9.613-61.378l-36.975 7.395c7.12 18.827 7.243 34.976-9.614 52.504z"
        fill="#ffb8b8"
      />
      <path
        d="M103.529 412.478l87.26 24.403 16.747-115.368a22.21 22.21 0 00-19.616-20.603l-20.055-2.314-36.236 3.697-17.138 4.843a22.128 22.128 0 00-16.087 22.292z"
        fill="#6c63ff"
      />
      <path
        d="M187.091 414.696l14.05 16.27 34.018-36.236-12.647-62.706a38.43 38.43 0 00-30.444-30.147l-9.413-1.802 20.705 84.302z"
        fill="#6c63ff"
      />
      <path
        d="M187.789 437.564l10.395-13.994-8.874-8.874-14.413 3.76a12.218 12.218 0 00-5.933 20.066 12.218 12.218 0 0018.825-.958z"
        fill="#ffb8b8"
      />
      <path
        d="M119.058 419.133l-14.05 16.27-34.017-36.236 12.646-62.706a38.43 38.43 0 0130.444-30.147l9.414-1.803-20.706 84.303z"
        fill="#6c63ff"
      />
      <path
        d="M118.36 442.001l-10.394-13.994 8.873-8.874 14.414 3.76a12.218 12.218 0 015.933 20.066 12.218 12.218 0 01-18.825-.958z"
        fill="#ffb8b8"
      />
      <circle cx={146.579} cy={249.809} r={25.673} fill="#ffb8b8" />
      <path
        d="M174.088 247.422h-43.905l-13.328-18.032c13.113-11.477 29.523-13.534 47.825-10.192z"
        fill="#2f2e41"
      />
      <circle cx={562.081} cy={160.023} r={60} fill="#e6e6e6" />
      <path fill="#6c63ff" d="M684.905 273.194h131.181v131.181H684.905z" />
      <path fill="#e6e6e6" d="M554.378 504.344h-70.322v-70.322h70.322z" />
      <circle cx={568.081} cy={623.023} r={30} fill="#6c63ff" />
    </svg>
  )
}

Icon.propTypes = {
  size: PropTypes.number.isRequired,
}

const CreativeDraf = styled(Icon)([], space, color, display)

CreativeDraf.displayName = 'CreativeDraf'

CreativeDraf.defaultProps = {
  size: 24,
}

export default CreativeDraf
